module.exports = __webpack_public_path__ + "static/ipo3-f030fad0b5dbd6d7f85f45ce79d52c59.jpg";